<template>
  <div class="app-container paper-subject">
    <basic-container class = "paper-subject-container">
      <div class="paper-subject-container-head">
        <el-row>
          <el-col :span="4">
            <el-button size="medium" type="primary" @click="showSubjectLib()">从题库中选择题目</el-button>
          </el-col>
          <el-col :span="20">
            <div class="paper-subject-container-head-count">
              <el-row>
                <el-col :span="18">
                  <span>单选题：{{ singleSubjectList.length }} 道</span>
                  <span class="vertical"> | </span>
                  <span >多选题：{{ mutipleSubjectList.length }} 道</span>
                  <span class="vertical"> | </span>
                  <span >判断题：{{ judgementSubjectList.length }} 道</span>
                  <span class="vertical"> | </span>
                  <span >填空题：{{ fillSubjectList.length }} 道</span>
                  <span class="vertical"> | </span>
                  <span >简答题：{{ questionSubjectList.length }} 道</span>
                </el-col>
                <el-col :span="6" style="text-align: right;">
                  <span style="margin-right: 15px;">总分： {{ totalScore }} 分</span>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <hr>
      </div>
      <div class="paper-subject-container-content">
        <div class="paper-subject-container-single" v-if="singleSubjectList.length > 0">
          <subject-component @setScore="setScore" :subjectDetailList="singleSubjectList" :type="subjectTypeMap.single.value"/>
        </div>
        <div class="paper-subject-container-single" v-if="mutipleSubjectList.length > 0">
          <subject-component @setScore="setScore" :subjectDetailList="mutipleSubjectList" :type="subjectTypeMap.mutiple.value"/>
        </div>
        <div class="paper-subject-container-single" v-if="judgementSubjectList.length > 0">
          <subject-component @setScore="setScore" :subjectDetailList="judgementSubjectList" :type="subjectTypeMap.judgement.value"/>
        </div>
        <div class="paper-subject-container-single" v-if="fillSubjectList.length > 0">
          <subject-component @setScore="setScore" :subjectDetailList="fillSubjectList" :type="subjectTypeMap.fill.value"/>
        </div>
        <div class="paper-subject-container-single" v-if="questionSubjectList.length > 0">
          <subject-component @setScore="setScore" :subjectDetailList="questionSubjectList" :type="subjectTypeMap.question.value"/>
        </div>
      </div>
    </basic-container>
    <el-dialog
      :visible.sync="subjectDialogVisible"
      title="从题库中选择题目"
      width="1200px"
      :destroy-on-close="true"
      @close="closeDialog">
      <el-row>
        <el-col :span="12">
          <dialog-component :tableOption="subjectLibDialogOption" :isSubjectLib="true" @handClickSubjectLib="handClickSubjectLib"/>
        </el-col>
        <el-col :span="12">
          <dialog-component ref="subjectList" :tableOption="subjectDialogOption" :isSubjectLib="false" :libId="libId"/>
          <span>没有合适题目，<em style="color: blue;" @click="goCreateSubjectLib">点击去创建</em></span>
        </el-col>
      </el-row>
      <span slot="footer">
        <template>
          <el-button @click="closeDialog">取消</el-button>
          <el-button class="article-submit-btn" type="primary" @click="subjectChoice">确认</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSubjectDetail, } from '@/api/app/subject'
import { mapGetters } from 'vuex'
import { subjectLibDialogOption, subjectDialogOption, subjectTypeMap, subjectTypeList } from '@/const/crud/app/subject-lib'
import dialogComponent from './dialog-component.vue'
import subjectComponent from './subject-component.vue'

export default {
  name: 'choice-subject',
  components: {
    dialogComponent,
    subjectComponent,
  },
  props: {
    subjects: {
      type: Array
    }
  },
  data() {
    return {
      subjectDialogVisible: false,
      subjectLibDialogOption,
      subjectDialogOption,
      subjectTypeMap,
      subjectTypeList,
      libId: '',
      singleSubjectList: [],
      mutipleSubjectList:[],
      judgementSubjectList: [],
      fillSubjectList: [],
      questionSubjectList: [],
    }
  },
  created() {
  },
  computed: {
    ...mapGetters(['permissions']),
    subjectChoiceList() {
      const subjects = [];
      this.pushSubjects(this.singleSubjectList, subjects);
      this.pushSubjects(this.mutipleSubjectList, subjects);
      this.pushSubjects(this.judgementSubjectList, subjects);
      this.pushSubjects(this.fillSubjectList, subjects);
      this.pushSubjects(this.questionSubjectList, subjects);
      for (let i = 0; i < subjects.length;  i++){
        subjects[i].subjectSort = i;
      }
      return subjects
    },
    totalScore() {
      let allScore = 0;
      this.singleSubjectList.forEach(item => {
          allScore = allScore + (item.score ? item.score : 0)
      })
      this.mutipleSubjectList.forEach(item => {
          allScore = allScore + (item.score ? item.score : 0)
      })
      this.judgementSubjectList.forEach(item => {
          allScore = allScore + (item.score ? item.score : 0)
      })
      this.fillSubjectList.forEach(item => {
          allScore = allScore + (item.score ? item.score : 0)
      })
      this.questionSubjectList.forEach(item => {
          allScore = allScore + (item.score ? item.score : 0)
      })
      return allScore;
    }
  },
  watch: {
    subjects: {
      handler() {
        this.initSubject();
      },
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    showSubjectLib() {
      this.subjectDialogVisible = true;
    },
    closeDialog() {
      this.subjectDialogVisible = false;
    },
    handClickSubjectLib(libId) {
      this.libId = libId;
    },
    goCreateSubjectLib() {
       this.$router.push({
        path: '/app/exam/subject-lib/add'
      })
    },
    subjectChoice() {
      this.initData(this.$refs.subjectList.selectSubjectList);
      this.closeDialog();
    },
    initSubject() {
      this.subjects.forEach(item => {
          let param = item.subject
          param.score = item.score
          param.sort = item.subjectSort
          param.relationId = item.id
          this.fillSubejctList(item.subject.type, param)
      })

    },
    setScore(value) {
      switch (value.type) {
        case this.subjectTypeMap.single.value:
          this.$set(this.singleSubjectList, value.index, value.value)
          break;
        case this.subjectTypeMap.mutiple.value:
          this.$set(this.mutipleSubjectList, value.index, value.value)
          break;
        case this.subjectTypeMap.judgement.value:
          this.$set(this.judgementSubjectList, value.index, value.value)
          break;
        case this.subjectTypeMap.fill.value:
          this.$set(this.fillSubjectList, value.index, value.value)
          break;
        case this.subjectTypeMap.question.value:
          this.$set(this.questionSubjectList, value.index, value.value)
          break;
        default:
          break;
      }
    },
    initData(data) {
      data.forEach(item => {
        this.fillSubejctList(item.type, item)
      })
    },
    fillSubejctList(type, item) {
      switch (type) {
        case this.subjectTypeMap.single.value:
        case this.subjectTypeMap.single.name:
          if (!this.singleSubjectList.some(val => val.id === item.id)) {
            this.singleSubjectList.push(item)
          }
          break;
        case this.subjectTypeMap.mutiple.value:
        case this.subjectTypeMap.mutiple.name:
          if (!this.mutipleSubjectList.some(val => val.id === item.id)) {
            this.mutipleSubjectList.push(item)
          }
          break;
        case this.subjectTypeMap.judgement.value:
        case this.subjectTypeMap.judgement.name:
          if (!this.judgementSubjectList.some(val => val.id === item.id)) {
            this.judgementSubjectList.push(item)
          }
          break;
        case this.subjectTypeMap.fill.value:
        case this.subjectTypeMap.fill.name:
          if (!this.fillSubjectList.some(val => val.id === item.id)) {
            this.fillSubjectList.push(item)
          }
          break;
        case this.subjectTypeMap.question.value:
        case this.subjectTypeMap.question.name:
          if (!this.questionSubjectList.some(val => val.id === item.id)) {
            this.questionSubjectList.push(item)
          }
          break;
        default:
          break;
      }
    },
    pushSubjects(list, subjects) {
      list.forEach(item => {
        subjects.push({
          id: item.relationId ? item.relationId : null,
          score: item.score ? item.score : 0,
          subjectId: item.id,
          subjectSort: ''
        });
      })
    }
  },
}
</script>

<style lang="scss" scoped>

.paper-subject {
  &-container {
    padding-top: 0px;
    &-head {
      padding-bottom: 10px;
      &-count {
        font-size: 16px;
        line-height: 36px;
        height: 36px;
      }
    }
    &-content {
      min-height: 300px;
    }
    &-single {
      margin-left: 40px;
      margin-right: 20px;
      text-align: left;
      &-content {
        margin-bottom: 10px;
      }
    }
  }
  .vertical {
    margin: 0 10px 0 10px;
  }
}
</style>
